<!-- Button -->
<button
  type="button"
  mat-icon-button
  class="user-trigger-btn"
  [class.user-trigger-btn--open]="userMenuOpened"
  [matMenuTriggerFor]="userActions"
  [matMenuTriggerRestoreFocus]="false"
  (menuOpened)="userMenuOpened = true"
  (menuClosed)="userMenuOpened = false"
  (mousedown)="$event.preventDefault()"
>
  <span class="relative">
    @if (showAvatar && user?.avatar) {
      <img class="h-7 w-7 rounded-full" [src]="$safeNavigationMigration(user?.avatar)" />
    }
    @if (!showAvatar || !user?.avatar) {
      <mat-icon
        class="mat-icon-white"
        [svgIcon]="'heroicons_outline:user-circle'"
      ></mat-icon>
    }
    <span
      class="absolute bottom-0 right-0 h-2 w-2 rounded-full"
      [ngClass]="{
        'mb-px mr-px': !showAvatar || !user?.avatar,
      }"
    ></span>
  </span>
</button>
<mat-menu
  #userActions="matMenu"
  xPosition="before"
  yPosition="below"
  [overlapTrigger]="false"
  class="user-menu-panel-layout"
>
  <div class="user-menu-card">
    @if (anonymousMode) {
      <button type="button" class="user-menu-row" (click)="login()">
        <div class="user-menu-text-wrap pl-4">
          <div class="user-menu-title">{{ "userdd.login" | transloco }}</div>
        </div>
      </button>
    } @else {
      <button class="user-menu-row" [routerLink]="'/accountsettings/myprofile'">
        <div class="user-menu-avatar">
          <svg
            class="user-menu-icon"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
            ></path>
          </svg>
        </div>
        <div class="user-menu-text-wrap">
          <div class="user-menu-title">
            {{ user?.firstName }} {{ user?.lastName }}
          </div>
          <div class="user-menu-subtitle">
            {{ "dashboard.topRight.signedInAs" | transloco }}
          </div>
        </div>
      </button>

      <div class="user-menu-divider"></div>

      <a
        type="button"
        class="user-menu-row"
        [href]="partnerPortalUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div class="user-menu-text-wrap pl-4">
          <div class="user-menu-title">Partner Portal</div>
          <div class="user-menu-subtitle">
            {{ "userdd.partnerportalOpenInNewTab" | transloco }}
          </div>
        </div>
        <svg
          class="user-menu-external-icon"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
          ></path>
        </svg>
      </a>

      <div class="user-menu-divider"></div>

      <button type="button" class="user-menu-row" (click)="signOut()">
        <!--
      <div class="user-menu-avatar user-menu-avatar--small">
        <svg
          class="user-menu-icon user-menu-icon--small"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9"
          ></path>
        </svg>
      </div>-->
        <div class="user-menu-text-wrap pl-4">
          <div class="user-menu-title">{{ "userdd.logout" | transloco }}</div>
          <div class="user-menu-subtitle">
            {{ "userdd.logoutSubtitle" | transloco }}
          </div>
        </div>
      </button>
    }
  </div>
</mat-menu>
